export const Table = `
	<Table>
		<TableHead>
			<TableRow>
				<TableCell>Song</TableCell>
				<TableCell>Artist</TableCell>
				<TableCell>Year</TableCell>
			</TableRow>
		</TableHead>
		<TableBody>
			<TableRow>
				<TableCell>
					The Sliding Mr. Bones (Next Stop, Pottersville)
				</TableCell>
				<TableCell>Malcolm Lockyer</TableCell>
				<TableCell>1961</TableCell>
			</TableRow>
			<TableRow>
				<TableCell>Witchy Woman</TableCell>
				<TableCell>The Eagles</TableCell>
				<TableCell>1972</TableCell>
			</TableRow>
			<TableRow>
				<TableCell>Shining Star</TableCell>
				<TableCell>Earth, Wind, and Fire</TableCell>
				<TableCell>1976</TableCell>
			</TableRow>
		</TableBody>
	</Table>
`
